<template>
<modal name="etc-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div class="setting">
    <div style="text-align: center;" v-if="$deviceLib.isApple">
        <p style="font-size: 130%; padding-bottom: 15px;">ダウンロードが完了しました！</p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
            <a href="https://apple.co/3GJbCB" target="_blank">
                <img src="/static/renew_img/app_download_bnr.png" style="width: 70%;" alt="ヤギッシュアプリをダウンロードしよう！">
            </a>
        </div>
        <button type="button" class="el-button el-button--success" id="send-mynabi-pdf" style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%; margin: 15px 0px 10px;"
        onClick="window.open('https://apple.co/3GJbCBo', '_blank');"><span>ダウンロードする</span></button>
        <p style="font-size: 130%; padding: 0 40px; font-weight: bold;">ヤギッシュアプリをダウンロードして、<br>いつでも編集できるようにしておこう！</p>
    </div>
    <div style="text-align: center;" v-else-if="$deviceLib.isAndroid">
        <p style="font-size: 130%; padding-bottom: 15px;">ダウンロードが完了しました！</p>
        <div style="display: inline-block; min-width: 100%; text-align: center;">
            <a href="https://bit.ly/3O01VRv" target="_blank">
                <img src="/static/renew_img/app_download_bnr.png" style="width: 70%;" alt="ヤギッシュアプリをダウンロードしよう！">
            </a>
        </div>
        <button type="button" class="el-button el-button--success" id="send-mynabi-pdf" style="background-color: rgb(246, 11, 38); border-color: rgb(246, 11, 38); font-size: 120%; margin: 15px 0px 10px;"
        onClick="window.open('https://bit.ly/3O01VRv', '_blank');"><span>ダウンロードする</span></button>
        <p style="font-size: 130%; padding: 0 40px; font-weight: bold;">ヤギッシュアプリをダウンロードして、<br>いつでも編集できるようにしておこう！</p>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended: false,
      isSendedJigen: false,
      fullscreenLoading: false,
      username: '',
      baite_title: 'バイト',
      isAgree: true
    }
  },
  created: function () {
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
      // console.log all the kay/value pairs
      if (key === 'basicData') {
        app.username = value.lastName + '_' + value.firstName
      }
    }, function (err) {
      if (!err) {
        console.log('Iteration has completed')
      }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openEtcDialog: function (id, html) {
      console.error('Etc openDialog')
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('etc-dialog')
      this.clearLocalStorageConfirmVisible = false

      if (!this.$deviceLib.isApple && !this.$deviceLib.isAndroid) {
        this.closeDialog()
      }

      const formData = new FormData()
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'etc_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('version', '2')
      formData.append('site_flag', 'r')
      formData.append('app_flag', this.$site.appFlag)
      const app = this
      this.$axios.post(this.$varuna.endPoints.displayDialog, formData, { timeout: 60000 })
      this.$iterateStorage(function (value, key, iterationNumber) {
        // console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
      }, function (err) {
        if (!err) {
          console.log('Iteration has completed')
        }
      })
    },
    closeDialog: function () {
      this.$modal.hide('etc-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendEtcConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      if (!this.isAgree) {
        this.$message({
          message: 'チェックしてから同意ボタンを押してください。',
          type: 'error'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', this.$site.appFlag)
      formData.append('dialog_name', 'etc_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('reqflg', '2')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.etcPdfMail, formData, { timeout: 60000 })
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '担当者からあなたに電話・メールでご連絡することがあります！',
            type: 'error'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    },
    sendEtcScout: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      const formData = this.pdfFormData
      console.log(accessToken)
      formData.append('token', accessToken)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('dialog_name', 'etc_dialog')
      formData.append('permission_type', this.permissionType)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP' : 'PC')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      formData.append('reqflg', '1')
      console.log(this.$firebase.config.apiKey)
      console.log(accessToken)
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.etcPdfMail, formData, { timeout: 60000 })
        .then(function (response) {
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: '担当者からあなたのメールアドレスにスカウトが届くことがあります！',
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-etc-consult', this.sendEtcConsult)
    this.$eventHub.$on('send-etc-scout', this.sendEtcScout)
    this.$eventHub.$on('open-etc-dialog', this.openEtcDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-etc-consult', this.sendEtcConsult)
    this.$eventHub.$off('send-etc-scout', this.sendEtcScout)
    this.$eventHub.$off('open-etc-dialog', this.openEtcDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
